import { render } from "./SplideMainCarousel.vue?vue&type=template&id=1d686eba"
import script from "./SplideMainCarousel.vue?vue&type=script&lang=js"
export * from "./SplideMainCarousel.vue?vue&type=script&lang=js"

import "./SplideMainCarousel.vue?vue&type=style&index=0&id=1d686eba&lang=css"
script.render = render

export default script